import { render, staticRenderFns } from "./FeedVideoItem.vue?vue&type=template&id=6dd5306a&"
import script from "./FeedVideoItem.vue?vue&type=script&lang=js&"
export * from "./FeedVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedVideoItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports